import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import FeedbackIncreaseLimits from './FeedbackIncreaseLimitsForm';
import * as styles from './FeedbackIncreaseLimits.scss';

class ModalFeedbackIncreaseLimits extends Component {
  render() {
    const {
      closeModal,
      openModal,
      isPackageUpdate,
      withoutSubtitle
    } = this.props;

    return (
      <Modal
        isOpen={openModal}
        shouldCloseOnOverlayClick
        onRequestClose={closeModal}
        className={styles.processModal}
        overlayClassName={styles.processOverlay}
      >
        <FeedbackIncreaseLimits
          closeModal={closeModal}
          isPackageUpdate={isPackageUpdate}
          withoutSubtitle={withoutSubtitle}
        />
      </Modal>
    );
  }
}

ModalFeedbackIncreaseLimits.propTypes = {
  closeModal: PropTypes.func,
  openModal: PropTypes.bool,
  isPackageUpdate: PropTypes.bool,
  withoutSubtitle: PropTypes.bool
};

export default ModalFeedbackIncreaseLimits;
